const React = require('react');

class SearchIcon extends React.Component {
    render() {
        return (
        <svg x="0px" y="0px" viewBox="0 0 45 45" className={this.props.className}>
            <g>
                <path fill="#5b1400" d="M41.1,39.7L30.2,28.9c1.9-2.5,3.1-5.7,3.1-9.1c0-8.3-6.7-15-15-15c-8.3,0-15,6.7-15,15c0,8.3,6.7,15,15,15
            c3.4,0,6.6-1.1,9.1-3.1l10.9,10.9c0.8,0.8,2,0.8,2.8,0C41.9,41.8,41.9,40.5,41.1,39.7z M18.3,30.8c-6.1,0-11-4.9-11-11
            s4.9-11,11-11s11,4.9,11,11S24.4,30.8,18.3,30.8z"/>
            </g>
        </svg>
        )
    }
}

module.exports = SearchIcon;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/SearchIcon/index.jsx